import React from "react";
import {useReactToPrint} from "react-to-print";
import {FunctionalComponentToPrint} from "./FichaMatriculaImpressao";
import {FunctionalFichaDisciplinaComponentToPrint} from "./FichaDisciplinasImpressao";
import {
    FunctionalFichaGradeGeralNotasAlunoComponentToPrint
} from "../Impressoes/ImpGradeNotasGeralAluno/FichaGradeGeralNotasAlunoImpressao";



const ImpressaoGradeNotasGeralAlunoCall = ( props: any ) => {
    const {eilId, eId, aluno} = props;
    
    const componentRef = React.useRef(null);
    
    const onBeforeGetContentResolve = React.useRef<(() => void) | null>(null);
    
    const [loading, setLoading] = React.useState(false);
    const [text, setText] = React.useState("Some cool text from the parent");
    
    const handleAfterPrint = React.useCallback(() => {
        console.log("`onAfterPrint` called"); // tslint:disable-line no-console
    }, []);
    
    const handleBeforePrint = React.useCallback(() => {
        console.log("`onBeforePrint` called"); // tslint:disable-line no-console
    }, []);
    
    const handleOnBeforeGetContent = React.useCallback(() => {
        console.log("`onBeforeGetContent` called"); // tslint:disable-line no-console
        setLoading(true);
        setText("Loading new text...");
        
        return new Promise<void>((resolve) => {
            onBeforeGetContentResolve.current = resolve;
            
            setTimeout(() => {
                setLoading(false);
                setText("New, Updated Text!");
                resolve();
            }, 2000);
        });
    }, [setLoading, setText]);
    
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);
    
    const handlePrint = useReactToPrint({
        content: reactToPrintContent,
        documentTitle: "DisciplinasAluno",
        onBeforeGetContent: handleOnBeforeGetContent,
        onBeforePrint: handleBeforePrint,
        onAfterPrint: handleAfterPrint,
        removeAfterPrint: true,
    });
    
    React.useEffect(() => {
        if (text === "New, Updated Text!" && typeof onBeforeGetContentResolve.current === "function") {
            onBeforeGetContentResolve.current();
        }
    }, [onBeforeGetContentResolve.current, text]);
    
    
    
    return (
        <React.Fragment>
            <div>
                {loading && <p className="indicator">Impressao: processando...</p>}
                <button onClick={handlePrint}>
                    PDF Grade Notas:{eId}
                </button>
                {/*<ReactToPrint*/}
                {/*    content={reactToPrintContent}*/}
                {/*    documentTitle={tit}*/}
                {/*    onAfterPrint={handleAfterPrint}*/}
                {/*    onBeforeGetContent={handleOnBeforeGetContent}*/}
                {/*    onBeforePrint={handleBeforePrint}*/}
                {/*    removeAfterPrint*/}
                {/*    trigger={ () => reactToPrintTrigger(e.id)}*/}
                {/*/>*/}
                {/*{loading && <p className="indicator">onBeforeGetContent: Loading...</p>}*/}
                <div hidden>
                    <FunctionalFichaGradeGeralNotasAlunoComponentToPrint ref={componentRef} eilId={eilId} eId={eId} aluno={aluno} text={text} />
                </div>
            </div>
        
        </React.Fragment>
    );
}
export default (ImpressaoGradeNotasGeralAlunoCall);